export const MIN_CANCELATION_WINDOW_INPUT = 0;
export const MAX_CANCELATION_WINDOW_INPUT = 999;
export const MAX_CANCELATION_WINDOW_INPUT_USC = 12;
